export default {
  groups: {
    general: '一般',
    navigation: '導覽',
    viewer: '3D 檢視器',
    editing: '編輯',
  },

  scopes: {
    global: '任何地方',
    viewer: '在 3D 檢視器中',
    designPoints: '在設計點表格中',
    reportWriteup: '在報告編輯器中',
  },

  status: {
    'scope-inactive': '此畫面無法使用',
    shadowed: '另一個指令正在使用這個按鍵',
    'handler-disabled': '目前無法使用',
    'no-handler': '這裡無法使用',
  },

  shortcut: {
    sequenceConnector: '→',
    unbound: '沒有快捷鍵',
  },

  recorder: {
    rebind: '變更',
    cancel: '取消',
    reset: '重設',
    listening: '請按下按鍵…',
    reserved: '3D 檢視器已經使用這個按鍵，請選擇其他按鍵。',
    unusable: '這個按鍵不能單獨作為快捷鍵，請搭配 Shift 或 Ctrl。',
    taken: '{{shortcut}} 已指派給「{{command}}」。',
    takeover: '仍要使用',
  },

  dialog: {
    title: '鍵盤快捷鍵',
    description:
      '按下快捷鍵旁的「變更」，然後按下想要的按鍵。錄製期間按 Esc 取消，按 Backspace 移除快捷鍵。',
    customized: '部分快捷鍵已與預設值不同。',
    resetAll: '全部重設',
  },

  conflicts: {
    heading: '兩個指令共用同一個按鍵',
    row: '{{shortcut}} — {{commands}}',
    // Joins the command names in a conflict row.
    separator: '、',
  },

  general: {
    showShortcuts: {
      title: '顯示鍵盤快捷鍵',
      description: '開啟這份清單。',
    },
    toggleAssistant: {
      title: '顯示或隱藏助理',
      description: '開啟右側的對話面板。',
    },
    closeOverlay: {
      title: '關閉開啟的對話框',
      description: '關閉最上層的內容。',
    },
  },

  navigation: {
    goHome: { title: '前往首頁' },
    goMeshgen: { title: '前往 MeshGen' },
    goSimops: { title: '前往 SimOps' },
  },

  viewer: {
    resetCamera: {
      title: '重設攝影機',
      description: '重新框住整個模型。',
    },
  },

  designPoints: {
    selectNext: { title: '選取下一個設計點' },
    selectPrevious: { title: '選取上一個設計點' },
    closeDetail: { title: '關閉詳細資料面板' },
  },

  reportWriteup: {
    save: {
      title: '儲存報告',
      description: '在編輯器中輸入時也能使用。',
    },
  },
};
